import React from 'react';

function KontaktpersonerOverblik() {
  const downloadCSV = () => {
    // URL'en peger nu på det endpoint, vi har genbrugt og opdateret.
    const url = `${process.env.REACT_APP_API_URL}/api/csv/kontaktpersoner-pr-sprogcenter`;
    window.open(url, '_blank');
  };

  return (
    <div className="report-subsection">
      <p>
        Denne funktion genererer en CSV-fil, der viser en samlet, pivoteret oversigt over alle 
        kontaktpersoner. Hvert sprogcenter har én række, og hver unik rolle (f.eks. Forstander, Prøveansvarlig) 
        får sine egne kolonner for navn, telefon og email.
      </p>
      
      <div className="report-action">
        <button 
          onClick={downloadCSV} 
          className="toggle-form-button"
        >
          Download Komplet Kontaktperson-oversigt (CSV)
        </button>
        <small>Listen er sorteret alfabetisk efter sprogcenter.</small>
      </div>
    </div>
  );
}

export default KontaktpersonerOverblik;